var _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTotalScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.001 304.332c75.452 0 136.81 61.36 136.81 136.811 0 12.706 10.293 22.999 23.003 22.999h116.22c12.714 0 23.007-10.293 23.007-22.999 0-164.875-134.169-299.038-299.041-299.038-12.706 0-23.003 10.294-23.003 23.003v116.222c0 12.68 10.297 23.002 23.003 23.002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M564.019 640.745c-8.97-8.97-23.548-8.97-32.518 0-26.624 26.624-62.165 41.316-99.918 41.316-77.894 0-141.238-63.402-141.238-141.238s63.344-141.237 141.238-141.237c12.71 0 23.003-10.294 23.003-23.003v-119.414c0-12.709-10.293-23.003-23.003-23.003-169.129 0-306.743 137.585-306.743 306.713s137.614 306.713 306.715 306.713c82.035 0 159.093-31.887 216.973-89.768 8.97-8.97 8.97-23.548 0-32.518l-84.509-84.562z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M839.074 511.713h-111.739c-12.706 0-23.003 10.293-23.003 23.003 0 34.963-13.574 67.772-38.244 92.385-4.309 4.313-6.726 10.179-6.726 16.273s2.441 11.964 6.726 16.273l79.045 79.073c4.313 4.317 10.179 6.73 16.273 6.73s11.964-2.445 16.273-6.73c54.432-54.456 84.423-126.89 84.423-203.977-0.033-12.767-10.322-23.032-23.028-23.032z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalScore);
export default __webpack_public_path__ + "static/media/icon-total-score.8550a2805841445ebe8045a23fdfdeec.svg";
export { ForwardRef as ReactComponent };